import CreateOpportunityDialog from './CreateOpportunityDialog';

export default CreateOpportunityDialog;
